document.addEventListener('DOMContentLoaded', function () {
  var menu = document.querySelector('.nye-mobile-menu');
  if (!menu) return;
  menu.addEventListener('click', function (event) {
    if (event.target.closest('a')) menu.open = false;
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', function (event) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

/* Fan actions only. Shopify checkout remains the authority for purchases. */
(function () {
  'use strict';
  function emit(name, details) {
    var shopify = window.Shopify;
    try {
      if (!shopify || !shopify.customerPrivacy ||
          typeof shopify.customerPrivacy.analyticsProcessingAllowed !== 'function' ||
          !shopify.customerPrivacy.analyticsProcessingAllowed() ||
          !shopify.analytics || typeof shopify.analytics.publish !== 'function') return;
      var result = shopify.analytics.publish('nye:' + name, details);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) { /* Analytics must never interrupt a fan's action. */ }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var destination;
    try { destination = new URL(link.href, window.location.href); } catch (error) { return; }
    if (link.hasAttribute('data-nye-social')) {
      emit('social_click', { platform: link.getAttribute('data-nye-social'), placement: link.closest('footer') ? 'footer' : 'menu' });
    } else if (['open.spotify.com', 'music.apple.com', 'www.youtube.com', 'youtube.com'].indexOf(destination.hostname) !== -1) {
      emit('listen_click', { platform: destination.hostname, placement: link.closest('#music') ? 'records' : 'site' });
    } else if (destination.origin === window.location.origin && ['#nye-backstage', '#nye-family'].indexOf(destination.hash) !== -1) {
      emit('join_interest', { destination: destination.hash === '#nye-family' ? 'free_email' : 'backstage' });
    }
  });
  document.addEventListener('submit', function (event) {
    if (event.target.id === 'NyeNewsletter') emit('newsletter_submit', { placement: 'footer' });
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('[data-nye-newsletter-success]')) emit('newsletter_confirmed', { placement: 'footer' });
  });
})();
